import { store } from "../redux/store";
import { setMarketPlace } from "../redux/reducers/marketPlace";
import type { useNavigate } from "@tanstack/react-router";
import { apiClient } from "../zodios/client";

export const handleDefaultMarketplace = async () => {
  // Get new list of available marketplaces
  const { amazon_seller_marketplaces: availableMarketplaces } = await apiClient.getSellerInfo();

  // Below will check is user has a preference stored for the org they are switching to
  if (availableMarketplaces) {
    const res = await apiClient.getUserProfile();
    const orgId = res.organization_id;
    const currentMarketplace = localStorage.Marketplace;
    const defaultMarketplace = res.default_marketplace?.[orgId] ?? "USA";

    // Set to new orgs stored default marketplace if current marketplace no longer relevant
    if (availableMarketplaces.includes(defaultMarketplace) && !availableMarketplaces.includes(currentMarketplace)) {
      localStorage.setItem("Marketplace", defaultMarketplace);
      store.dispatch(setMarketPlace(defaultMarketplace));
    }

    // Fallback in case no stored default is to first available choice
    if (!defaultMarketplace && !availableMarketplaces.includes(currentMarketplace)) {
      localStorage.setItem("Marketplace", availableMarketplaces[0]!);
      store.dispatch(setMarketPlace(availableMarketplaces[0]!));
    }
  }
};

export const handleProfileOrMarketplaceChangeRedirects = (navigate: ReturnType<typeof useNavigate>) => {
  // Below eliminates redirects on every profile change if number in hostname (localhost, etc.)
  const route = window.location.href.split(window.location.origin)[1]!;
  // Check if an entity id exists in URL, if so, return to merch dashboard on profile change
  if (/\d/.test(route)) {
    void navigate({ to: "/user/dashboard" });
  }
};
